document.addEventListener('DOMContentLoaded', () => {
  const subTitles = document.querySelectorAll('.advantages__sub-title')

  if (subTitles) {
    let resize = () => {
      let height = 0
      subTitles.forEach(subTitle => {
        subTitle.removeAttribute('style')
        if(subTitle.clientHeight > height) height = subTitle.clientHeight
      })

      subTitles.forEach(subTitle => {
        subTitle.style.setProperty('--height', `${height}px`)
      })
    }
    resize()
    window.addEventListener('resize', resize)
  }
})